export const getDefaultFilters = ({ CoAList }) => CoAList.searchFilter;
export const getListPageTitle = ({ CoAList }) => CoAList.searchLabel;
export const getListAlertModal = ({ CoAList }) => CoAList.alert;
export const getListConfirmModal = ({ CoAList }) => CoAList.confirmModal;

export const getCurrentPage = ({ CoAList }) => CoAList.searchFilter.Pagination.Page;
export const getSortModel = ({ CoAList }) => CoAList.resultTable.appliedFilter.Pagination.Sort;
export const getRowsPerPage = ({ CoAList }) => CoAList.resultTable.rowsPerPage;
export const isTableLoading = ({ CoAList }) => CoAList.resultTable.loading;
export const getTableData = ({ CoAList }) => CoAList.resultTable.data;
export const getTotalCount = ({ CoAList }) => CoAList.resultTable.totalCount;
export const getTableSelectedRows = ({ CoAList }) => CoAList.resultTable.selectedRows;

export const getddlData = ({ CoAList }) => CoAList.approverddl;
export const getAlertModalData = ({ CoAList }) => CoAList.alert;
export const getShowLoading = ({ CoAList }) => CoAList.loading;
export const getUpdateValues = ({ CoAList }) => CoAList.updateValues;
